// extracted by mini-css-extract-plugin
export default {"container":"WatchlistManagerListComponent_container__sGV01","selectedContainer":"WatchlistManagerListComponent_selectedContainer__I00PU"};